import React, { useEffect, useState } from "react";
import {
    Col, Modal, ModalHeader, ModalBody, ModalFooter, Row, Label
} from "reactstrap";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import SelectOptions from "components/SelectOptions"
import AreaService from "services/Admin/AreasService"
import { toast } from "react-toastify";
import moment from "moment"

const initialState = {
    from_date: "",
    to_date: "",
    has_deal: false,
    location: null,
}

const FilterModal = ({ modal, toggle, onSumbit ,filterData}) => {
    const [formState, setFormState] = useState(initialState)
    const [areaOptions, setAreaOptions] = useState([])

    const handleFieldChange = (e) => {
        setFormState({ ...formState, [e.target.name]: e.target.value })
    }
    useEffect(()=>{
        if (filterData ?.from_date ?.length) setFormState((state) => ({ ...state, from_date: filterData.from_date }))
        if (filterData ?.to_date ?.length) setFormState((state) => ({ ...state, to_date: filterData.to_date }))
        if (filterData ?.location?.length) setFormState((state) => ({ ...state, location: filterData.location }))
        if (filterData ?.has_deal) setFormState((state) => ({ ...state, has_deal: filterData.has_deal }))

    },[])

    const handleValidSubmit = () => {
        if (moment(formState.to_date).isBefore(formState.from_date)) {
            toast.error("Date range not valid")
            return
        }
        else {
            onSumbit(formState)
            toggle()
        }
    }

    return (
        <AvForm className='form-horizontal'   >
            <Modal isOpen={modal} toggle={toggle}
                className="rightModalSide scrollbar-container mt-0">
                <ModalHeader toggle={toggle}>
                    Leads Filters
            </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12}   >
                            <SelectOptions
                                label='Area'
                                placeholder='Select'
                                options={areaOptions}
                                handleSelectChange={(data) => {
                                    setFormState({ ...formState, location: data });
                                }}
                                selectedOption={formState.location}
                                Service={AreaService}
                                setOptions={(options) => {
                                    setAreaOptions(options)
                                }}
                                isMulti={true}

                            />
                        </Col>
                        <Col md={12}>
                            <div className='mb-3'>
                                <AvField
                                    name='from_date'
                                    label="from Date"
                                    className='form-control'
                                    type='date'
                                    onChange={(e) => handleFieldChange(e)}
                                    bsSize="lg"
                                    value={formState.from_date}
 
                                />
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='mb-3'>
                                <AvField
                                    name='to_date'
                                    label=" to Date"
                                    className='form-control'
                                    type='date'
                                     onChange={(e) => handleFieldChange(e)}
                                    bsSize="lg"
                                    value={formState.to_date}

                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Label>Has Open Deal</Label>
                        <form>
                            <div className='form-check form-switch form-switch-md mb-1'>
                                <input
                                    name='status'
                                    checked={formState.has_deal}
                                    type='checkbox'
                                    className='form-check-input'
                                    id='has_status'
                                    onChange={() => {
                                        setFormState((formState) => ({ ...formState, has_deal: !formState.has_deal }))

                                    }}
                                />
                            </div>
                        </form>
                    </Row>

                </ModalBody>
                <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                    <button
                        type='button'
                        className='btn btn-light w-120'
                        onClick={() => {
                            onSumbit(initialState)
                            setFormState({ ...initialState })
                        }}>
                        Reset Filter
                       </button>
                    <button type="button"
                        onClick={handleValidSubmit}
                        className='btn btn-success  w-120'>
                        Apply Filter
                    </button>
                </ModalFooter>

            </Modal>
        </AvForm>

    )
}
export default FilterModal